import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import screeningLogo from '../../../../assets/img/skrinig40.svg';
import './style.scss';
import { isMobile } from '../../../../utils/mobile';
import MobileNotice from '../mobileNotice';

export default function ScreeningBanner({ mini = false }) {
  return (
    <section className="screening-banner-section">
      <Container>
        <Row className="align-items-stretch">
          {!isMobile() && <Col md={{ span: 3 }} className="d-flex"><MobileNotice /></Col>}
          <Col md={{ span: isMobile() ? 10 : 9 }} lg={{ span: isMobile() ? 8 : 9, offset: isMobile() ? 2 : 0 }}>

            <Link to="/national-screening" className={`screening-banner${mini ? ' screening-banner--mini-only' : ''}`}>
              <div className="screening-banner__content">
                <div className="screening-banner__logo">
                  <img src={screeningLogo} alt="Скринінг здоров'я 40+" />
                </div>
                <div className="screening-banner__text">
                  <h3 className="screening-banner__title">Національний скринінг здоров'я 40+</h3>
                  <p className="screening-banner__description">
                    Безкоштовна перевірка здоров'я для людей від 40 років. 
                    Раннє виявлення ризиків серцево-судинних захворювань і діабету.
                  </p>
                  <div className="screening-banner__cta">
                    <span className="screening-banner__btn">
                      Дізнатися більше
                      <i className="fas fa-arrow-right ml-2" />
                    </span>
                  </div>
                </div>
              </div>
              <div className="screening-banner__mini">
                <img src={screeningLogo} alt="Скринінг здоров'я 40+" className="screening-banner__mini-logo" />
                <span className="screening-banner__mini-btn">
                  Дізнатися більше
                  <i className="fas fa-arrow-right" />
                </span>
              </div>
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
